import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { Sizes } from "../../../Constants/Constants";
import { AvatarSizeData, SizesSubTitle } from "../../../Data/UiKits/Avatars";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const AvatarSizes = () => {
  return (
    <Col xl="4" md="6">
      <Card className="height-equal">
        <CommonCardHeader title={Sizes} span={SizesSubTitle} />
        <CardBody className="avatar-showcase">
          <div className="avatars">
            {AvatarSizeData &&
              AvatarSizeData.map((item, index) => (
                <div key={index} className="avatar">
                  <Image className={`img-${item.class} rounded-circle`} src={dynamicImage(`avtar/${item.image}`)} alt="user profile" />
                </div>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AvatarSizes;
